import { functionsBaseUrl } from "../../firebase";

export const MapsService = {
    geocodeProxy: async (lat: number, lng: number): Promise<any> => {
    const response = await fetch(`${functionsBaseUrl}/geocodeProxy?lat=${lat}&lng=${lng}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    console.log(response)
    if (response.status === 200) {
      return await response.json();
    } 
    return undefined;
  },
  distance: (lat1: number, lon1: number, lat2: number, lon2: number) => {
      const dx = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2 * (Math.PI / 180));
      const dy = lat2 - lat1;
      const distance = Math.sqrt(dx * dx + dy * dy) * 111; // 111 km per degree
      return distance.toFixed(2);
  }
}